import { z } from "zod";
import { IdPrefix, generateId } from "../utils";
import type { CompartmentType } from "./Compartment";

export const DOOR_THICKNESS = 18;
export const DOOR_MARGIN = 4;

const DoorSideSchema = z.union([z.literal("left"), z.literal("right")]);

export const DoorSchema = z.object({
	id: z.string(),
	x: z.number(),
	y: z.number(),
	z: z.number(),
	width: z.number().min(150).max(600),
	height: z.number().min(300).max(2000),
	depth: z.number(),

	type: z.literal("single"),
	side: DoorSideSchema,
});

DoorSchema.refine((val) => val.height >= val.width, {
	message: "Door height must be larger than the width",
});

export type Door = z.infer<typeof DoorSchema>;
export type DoorSide = z.infer<typeof DoorSideSchema>;

export function createDoor(compartment: CompartmentType, side: DoorSide): Door {
	return {
		id: generateId(IdPrefix.Door),
		side,
		type: "single",
		x: compartment.x + DOOR_MARGIN / 2,
		y: compartment.y + DOOR_MARGIN / 2,
		z: compartment.z + compartment.depth - DOOR_THICKNESS,
		width: compartment.height - DOOR_MARGIN,
		height: DOOR_THICKNESS,
		depth: compartment.width - DOOR_MARGIN,
	};
}
